import React from 'react'

import * as Footers from '../Footers'

const CONTAINER_STYLES =
  'flex flex-col min-h-screen h-auto w-screen lg:h-screen overflow-x-hidden'
const VIEW_CONTENT_STYLES =
  'flex flex-col flex-grow flex-shrink h-auto lg:flex-row lg:h-screen m-0 box-border'
const CONTENT_STYLES =
  'bg-contentareabackground overflow-x-hidden md:overflow-y-auto w-full xl:w-1/3 m-0 box-border'
const DECORATIVE_STYLES =
  'flex flex-col flex-grow w-full xl:w-2/3 m-0 box-border'
const SPLASH_STYLES =
  'bg-cover bg-accent h-50-screen flex-1 md:h-70-screen lg:h-auto'
export interface ISplashImageViewProps {
  backgroundImageSrc: string
  footerImageSrc: string
  splashContent?: JSX.Element
  children: JSX.Element | JSX.Element[]
}

/**
 * A responsive template that displays a large splash image on
 * the right hand side of the screen.
 * @param props A configuration for the content and display of this template.
 */
export const SplashImageView: React.FC<ISplashImageViewProps> = ({
  backgroundImageSrc,
  footerImageSrc,
  children,
  splashContent,
}) => (
  <div className={CONTAINER_STYLES}>
    <div className={VIEW_CONTENT_STYLES}>
      <div className={CONTENT_STYLES}>{children}</div>
      <div className={DECORATIVE_STYLES}>
        <div
          className={SPLASH_STYLES}
          style={{ backgroundImage: `url(${backgroundImageSrc})` }}
        />
        {splashContent}
      </div>
    </div>
    <Footers.Standard footerImageSrc={footerImageSrc} />
  </div>
)
